import AccessControl from './access-control';
import ProtectedRouteComponent from './protected-route';

export const ProtectedRoute = ProtectedRouteComponent;
export default AccessControl;


// WEBPACK FOOTER //
// ./src/services/access-control/index.js